















import Vue from 'vue';

export default Vue.extend({
  name: 'ClearButton',
  data: () => ({}),
  methods: {
    handleClick() {
      setTimeout(() => {
        this.$emit('click');
      }, 500);
    },
  },
});
